
import React from 'react';
import DashboardView from '../../components/DashboardView';

interface DashboardProps {
  userProfile?: any;
  onNavigate?: (path: string) => void;
  onNavigateToRechnung?: (id: string) => void;
  onNavigateToTicket?: (id: string) => void;
  onNavigateToEmail?: (id: string) => void;
}

// EIN Dashboard für alle Mitarbeitenden (Admin wie Team): das Tages-Briefing.
// Bis 2026-08-06 bekam die Rolle 'team' ein eigenes Dashboard mit fest verdrahteten
// Zahlen (12 Objekte, 08 Anfragen, 14 Belege) und erfundenen Aktivitäten — weder
// Briefing noch echte Kennzahlen. Die persönliche Sicht steckt im Umschalter
// „Meine Aufgaben / Alles" von DashboardView.
const Dashboard: React.FC<DashboardProps> = ({ userProfile, onNavigate, onNavigateToRechnung, onNavigateToTicket, onNavigateToEmail }) => (
  <DashboardView
    userProfile={userProfile}
    onNavigate={onNavigate}
    onNavigateToRechnung={onNavigateToRechnung}
    onNavigateToTicket={onNavigateToTicket}
    onNavigateToEmail={onNavigateToEmail}
  />
);

export default Dashboard;
